import { FormattedMessage } from "react-intl";
import { Button } from "@shltelemedicine/shl-ui-lib";
import addStudyIcon from "../../../../assets/buttons/study_add.svg";

import styles from "./AddStudyBanner.module.css";

type AddStudyBannerProps = {
  hasStudies?: boolean;
  onClick?: () => void;
};

const AddStudyBanner = ({ hasStudies, onClick }: AddStudyBannerProps) => (
  <div
    className={`${styles.addStudyBanner} ${!hasStudies &&
      styles.noStudies} d-flex align-items-center p-2`}
  >
    <Button
      variant=""
      className={styles.addBtn}
      icon={{ src: addStudyIcon, width: 18, height: 18 }}
      onClick={onClick}
    >
      <FormattedMessage
        id="MANAGEMENT.STUDIES.ADD_STUDY"
        defaultMessage="Add Study"
      />
    </Button>
    {!hasStudies && (
      <span className="mx-2">
        <FormattedMessage
          id="MANAGEMENT.EMPTY_STUDIES"
          defaultMessage="Start by creating a new study"
        />
      </span>
    )}
  </div>
);

export default AddStudyBanner;
